"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HideIcon = exports.HideWrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 6px;\n  height: 2px;\n  background: rgb(255, 255, 255);\n  border-radius: 4px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0;\n  position: absolute;\n  transform: scale(0);\n  top: 0px;\n  right: -22px;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  display: flex;\n  z-index: 999;\n  transition: all 0.3s;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.18s ease-out 0.18s;\n  background: rgba(0, 0, 0, 0.15);\n  border-radius: 20px;\n  &:hover {\n    background: rgba(0, 0, 0, 0.35);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HideWrapper = (0, _styledComponents.default)('div')(_templateObject());
exports.HideWrapper = HideWrapper;
var HideIcon = (0, _styledComponents.default)('div')(_templateObject2());
exports.HideIcon = HideIcon;

var _default = function _default(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement(HideWrapper, {
    id: "umi-ui-mini-hide",
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(HideIcon, null));
};

exports.default = _default;